import { Translations } from '~/app/i18n/i18n';

export default function getTranslatedLabel(
	translations: Translations,
	i18nKey: string | undefined | null,
	defaultText: string | undefined | null,
): string {
	if (i18nKey) {
		const translatedText = translations[i18nKey];
		if (!translatedText) {
			return defaultText!;
		}

		return translatedText;
	}

	return defaultText!;
}
